<footer class="text-secondary d-flex fs-5 justify-content-center m-3">
  <div>
    <a [href]="WHATS_NEW" target="_blank">{{ version() }}</a>
    <span class="ms-1">{{ name }}</span>
  </div>
  <div class="mx-1">·</div>
  <a [routerLink]="['/about']" i18n>About</a>
  <div class="mx-1">·</div>
  <div i18n>{{ year }} © Copado Holdings, Inc.</div>
  <div class="mx-1">·</div>
  <ng-template i18n #multipleOrgTooltip>Organization that is currently selected</ng-template>
  <div>
    <a
      [ngbTooltip]="multipleOrgTooltip"
      [queryParams]="{ orgId: org()?.id, projectId: projectId() }"
      [routerLink]="['/orgs/settings']"
      queryParamsHandling="replace"
      >{{ org()?.name }}</a
    >
  </div>
</footer>
